import React from 'react';
import { bestSellers } from '../data/products';
import { brand } from '../data/brand';
export function BestSellers() {
  return <section id="best-sellers" aria-labelledby="best-sellers-heading" className="w-full bg-white pb-24 pt-4 md:pb-36 md:pt-6" data-id="element-15" data-mp="ua8y9fl4ifhe">
      <div className="mx-auto max-w-editorial px-6 md:px-12 lg:px-20" data-id="element-16" data-mp="147ddswkgrcp8">
        <div className="flex flex-col items-center text-center" data-id="element-17" data-mp="149828kuy1my2">
          <h2 id="best-sellers-heading" className="font-serif text-[2rem] uppercase leading-tight tracking-[0.06em] text-maroon md:text-[2.6rem]" data-id="element-18" data-mp="1i5lixrrnlkbh">
            Best Sellers
          </h2>
        </div>

        <ul className="mx-auto mt-12 grid max-w-4xl grid-cols-1 gap-x-12 gap-y-14 sm:grid-cols-2 md:mt-16" data-id="element-19" data-mp="1rysnxbiheyb1">
          {bestSellers.map(product => <li key={product.id} className="group flex h-full flex-col text-center" data-id="element-20" data-mp="20yfojv3e0031">
              <div className="overflow-hidden bg-ivory" data-id="element-21" data-mp="1vyt7tboco1ph">
                <img src={product.image} alt={product.name} className="aspect-square w-full object-cover transition-transform duration-300 ease-luxe group-hover:scale-[1.03]" data-id="element-22" data-mp="1vw88atbixxuw" />
              </div>
              <h3 className="mt-6 font-serif text-[18px] font-light text-maroon" data-id="element-23" data-mp="3ly4fl8dwotyc">
                {product.name}
              </h3>
              <p className="mt-2 font-sans text-[12px] font-light uppercase tracking-[0.14em] text-maroon-mute" data-id="element-24" data-mp="3qvxm62j4fpz5">
                {product.detail}
              </p>
              <p className="mt-3 font-serif text-xl text-maroon" data-id="element-25" data-mp="3rzt71gbyz7r">{product.price}</p>
            </li>)}
        </ul>

        <div className="mt-14 flex w-full justify-center md:mt-20" data-id="element-26" data-mp="8ksutggi5rfm">
          <a href={brand.shopAllHref} className="inline-flex w-full max-w-sm items-center justify-center whitespace-nowrap rounded-[2px] bg-gold px-10 py-5 text-center font-display text-[12px] font-medium uppercase leading-none tracking-[0.22em] text-white shadow-[0_0_24px_rgba(217,159,89,0.35)] transition-[background-color,box-shadow] duration-200 ease-luxe hover:bg-gold-deep hover:shadow-[0_0_32px_rgba(217,159,89,0.5)] focus-visible:bg-gold-deep focus-visible:outline-none sm:w-auto sm:max-w-none sm:px-20 sm:py-6 sm:text-[13px]" data-id="element-27" data-mp="di2ml2rd6f6m">
            Explore full collection
          </a>
        </div>
      </div>
    </section>;
}